// @ts-strict-ignore
import { Component, ContentChild, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
    selector: 'ui-input-radio',
    templateUrl: './input-radio.component.html',
    styleUrls: ['./input-radio.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputRadioComponent<T> extends InputBaseComponent<string> {
  @Input() optionLabel: string;
  @Input() optionValue: string;
  @Input() controlName: string;
  @Input() options: T[];
  @Input() name: string = uniqueId('radio');
  @Input() placeholder: string = '';
  @ContentChild(TemplateRef) optionTemplate;

  selectedItem: T;

  onValueChange(item: T) {
    this.selectedItem = item;
    this._emit();
  }
  getLabel(item: T) {
    if (this.optionLabel) {
      return item[this.optionLabel];
    }
    return item;
  }
  getOptionId(index: number) {
    return `${this.name}_${index}`;
  }
  getValue(item: T) {
    if (this.optionValue) {
      return item[this.optionValue];
    }
    return item;
  }
  writeValue(value: any) {
    this.selectedItem = this.options.find((option) => {
      if (this.optionValue) {
        return option[this.optionValue] === value;
      }
      return option === value;
    });
  }
  private _emit() {
    if (this.optionValue) {
      this.onChange(this.selectedItem?.[this.optionValue] ?? undefined);
    } else {
      this.onChange(this.selectedItem?.toString() ?? undefined);
    }

    this.onTouched();
  }
}
